__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/c0d58a4/_next/";